<div class="d-flex">
  <div class="timeInput">
    <div class="selector-label">Uren</div>
    <mat-form-field class="timeInput" appearance="outline">
      <mat-select
        matInput
        class="timeInputSelect"
        required
        [(ngModel)]="hourBudget"
        name="hourBudget"
        (ngModelChange)="setHours($event)"
        [compareWith]="compareNumbers"
      >
        <mat-option
          *ngFor="let option of hours"
          [value]="option"
          class="timeInputSelect"
        >
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="largeText">:</div>

  <div class="timeInput">
    <div class="selector-label">Minuten</div>
    <mat-form-field class="timeInput" appearance="outline">
      <mat-select
        matInput
        class="timeInputSelect"
        required
        [(ngModel)]="minuteBudget"
        name="minuteBudget"
        (ngModelChange)="setMinutes($event)"
        [compareWith]="compareNumbers"
      >
        <mat-option
          *ngFor="let option of minutes"
          [value]="option"
          class="timeInputSelect"
        >
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
